module.exports = __webpack_public_path__ + "img/Coat_of_arms_of_Aruba-lines.30d8ac17.svg";